<template>
  <component :is="component" v-if="component" :product="product" :ranking="ranking" :location="location" :isFavoriteList="isFavoriteList" :loggedIn="loggedIn"/>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    templateNumber: {
      type: Number,
      required: true
    },
    ranking: {
      type: Number,
      required: false
    },
    location: {
      type: String,
      required: false
    },
    isFavoriteList: {
      type: Boolean,
      default: false,
    },
    loggedIn: {
      type: Boolean,
      default: false,
    }
  },
  data: function() {
    return {
      component: null
    };
  },
  computed: {
    loader: function() {
      if (!this.templateNumber) {
        return null;
      }

      return () => import(`./ProductTemplates/Style${this.templateNumber}`);
    }
  },
  mounted: function() {
    this.loader()
      .then(() => {
        this.component = () => this.loader();
      })
      .catch(() => {
        this.component = () => import("./ProductTemplates/Default");
      });
  }
};
</script>
